// Imported eagerly by index.ts, so keep this file free of heavy imports.
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";

const PREVIEW_PARAMS = [
  "redo-spotlight-test",
  "spotlight-id",
  "spotlight-object",
];

export const hasSpotlightToShow = ({
  autocheck,
  queryParameters,
}: {
  autocheck: WidgetAutocheck;
  queryParameters: URLSearchParams;
}): boolean =>
  // undefined is an autocheck from before the flag existed, so load as before
  autocheck.marketing?.hasEnabledNonEmbeddedSpotlights !== false ||
  PREVIEW_PARAMS.some((param) => queryParameters.has(param));
